import { BlurInH2 } from '../../eldora-ui/blur-in-h2';
import TitleBox from './TitleBox';

const TechnologyCertifications = () => {
  return (
    <section
      className="mt-24 scroll-mt-[150px] bg-gray-50"
      id="technology-certifications"
    >
      <div className="container mx-auto grid grid-cols-5 pr-5 mt-10">
        <div className="col-span-1"></div>
        {/* Desktop View */}
        <div className="col-span-4 hidden md:grid grid-cols-6 gap-0 h-[700px]">
          {/* First Half - 3 Columns */}
          <div className="col-span-2 grid grid-cols-2 grid-rows-3">
            {/* Top Section */}
            <div className="col-span-2 row-span-1 grid grid-rows-1 grid-cols-3">
              <div className="col-span-2 row-span-1 grid grid-rows-1 grid-cols-3">
                <BlurInH2 className="mt-10 w-[50%]">
                  Technology{' '}
                  <span className="font-light text-[#BF984D]">
                    Certifications
                  </span>
                </BlurInH2>
              </div>
            </div>

            {/* Bottom Section */}
            <div
              className="col-span-2 row-span-2 bg-image grid grid-rows-2"
              style={{
                backgroundImage: `url('/TechnologyCertifications/tc1.svg')`,
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div className="col-span-1 row-span-1 row-start-2 bg-[rgba(211,211,211,0.5)]" />
            </div>
          </div>

          {/* Second Half - 4 Columns */}
          <div className="col-span-4 grid grid-cols-4 grid-rows-3 border border-[#BF984D]">
            {/* Top Section */}
            <div
              className="col-span-4 row-span-2 bg-image grid grid-rows-2 grid-cols-4"
              style={{
                backgroundImage: `url('/TechnologyCertifications/tc2.svg')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <TitleBox
                title={'Simplicity®\n Certified'}
                subtitle={'Low Code Development Platform (LCDP) Developer'}
                link={'https://anacle.com/contact-us/'}
                isExternal={false}
                colSpan={1}
                rowSpan={1}
              />
              <div className="col-span-1 row-span-1 col-start-2 bg-[rgba(211,211,211,0.5)] border border-[#BF984D]" />
              <div className="col-span-1 row-span-1 col-start-3 border border-[#BF984D]" />
              <div className="col-span-1 row-span-1 col-start-4 border border-[#BF984D]" />
              <div className="col-span-1 row-span-1 row-start-2 bg-[rgba(211,211,211,0.5)] border border-[#BF984D]" />
              <TitleBox
                title={''}
                subtitle={'Simplicity®\n Certified\n LCDP Architect'}
                link={'https://anacle.com/contact-us/'}
                isExternal={false}
                colSpan={1}
                rowSpan={1}
              />
              <div className="col-span-1 row-span-1 row-start-2 border border-[#BF984D]" />
              <div className="col-span-1 row-span-1 col-start-4 bg-[rgba(211,211,211,0.5)] border border-[#BF984D]" />
            </div>

            {/* Bottom Section */}
            <div
              className="col-span-4 row-span-2 grid grid-rows-1 grid-cols-2 border border-[#BF984D]"
              style={{
                backgroundImage: `url('/TechnologyCertifications/tc3.svg')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div className="col-span-1 row-span-1 col-start-2 bg-[rgba(211,211,211,0.5)] border-l-2 border-[#BF984D]" />
            </div>
          </div>
        </div>
        {/* Mobile View */}
        <div className="block md:hidden col-span-5">
          <BlurInH2 className="text-start text-3xl mb-6">
            Technology{' '}
            <span className="font-light text-[#BF984D]">Certifications</span>
          </BlurInH2>

          <div className="flex flex-col space-y-6">
            <TitleBox
              key={0}
              title={'Simplicity® Certified'}
              subtitle="Low Code Development Platform (LCDP) Developer"
              link={'https://anacle.com/contact-us/'}
              isExternal={false}
            />
            <TitleBox
              key={1}
              title={''}
              subtitle="Simplicity® Certified LCDP Architect"
              link={'https://anacle.com/contact-us/'}
              isExternal={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologyCertifications;
